import { createRouteRef } from '@backstage/core-plugin-api';

export const topologyRouteRef = createRouteRef({
  id: 'appfolio.explore.topology',
});

export const toolsRouteRef = createRouteRef({
  id: 'appfolio.explore.tools',
});
